import React from "react";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import Button from "../../buttons/button";
import {ButtonVariant} from "../../buttons/button-const.ts";

export interface ConfirmDialogProps {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    title: string;
    message: string;
    confirmLabel: string;
    cancelLabel: string;
    
    logo?: React.ReactElement;
    confirmButtonVariant: ButtonVariant;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, onConfirm, onCancel, title, message, confirmLabel, cancelLabel, logo, confirmButtonVariant }) => (
    <Dialog open={open} onClose={onCancel} className='relative z-13'>
        <DialogBackdrop
            transition
            className='fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in'
        />

        <div className='fixed inset-0 w-screen overflow-y-auto'>
            <div className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
                <DialogPanel
                    transition
                    className='relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-closed:sm:translate-y-0 data-closed:sm:scale-95'
                >
                    <div className='sm:flex sm:items-start'>
                        <DialogTitle as='h3' className='text-base font-semibold text-gray-900'>
                            {title}
                        </DialogTitle>
                    </div>
                    <div className='mt-2 text-sm text-gray-700 flex flex-row gap-x-4 items-center'>
                        {logo}
                        {message}
                    </div>

                    <div className='mt-6 sm:flex sm:flex-row-reverse gap-2'>
                        <Button onClick={onConfirm} type='button' variant={confirmButtonVariant}>
                            {confirmLabel}
                        </Button>
                        <Button onClick={onCancel} type='button' variant='ghost'>
                            {cancelLabel}
                        </Button>
                    </div>
                </DialogPanel>
            </div>
        </div>
    </Dialog>
);

export default ConfirmDialog;